import React from 'react'
import { AutocompleteAjaxSeeker, ButtonLoadingSeeker, IconSeeker, ModalSeeker } from "@ui-seeker/core"
import { multipleModalIds, multipleUsersModalOption } from "Pages/Admin/Users/@signals"
import { Divider, Grid } from "@mui/material"
import { AppAsyncOfficesAutocomplete, AppSitesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { batch } from "@preact/signals-react"
import { USER_MULTI_OPTIONS } from "Pages/Admin/Users/@constans"
import { useEditUsersModal } from "Pages/Admin/Users/@hooks"


export default function MultipleUsersModal() {

	const { handleSubmit, selectorData, setSelectorData, isSubmitLoading, modalPayload } = useEditUsersModal()

	if (!multipleModalIds.value.length || !multipleUsersModalOption.value) return null

	return <ModalSeeker
		hideActions
		title="Edit multiple users offices/sites"
		controller={() => batch(() => {
			multipleModalIds.value = []
			multipleUsersModalOption.value = null
			setSelectorData([])
		})}
		isOpen={!!multipleModalIds.value.length && !!multipleUsersModalOption.value}
	>

		<Grid container spacing={2}>
			<Grid item xs={3}/>
			{multipleUsersModalOption.value === USER_MULTI_OPTIONS.SITE && <Grid item xs={6} sx={{ my: 3 }}>
				<AppSitesAutocomplete
					multiple
					urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/sites`}
					value={selectorData}
					onChange={e => setSelectorData(e.target.value)}
				/>
			</Grid>}
			{multipleUsersModalOption.value === USER_MULTI_OPTIONS.OFFICE && <Grid item xs={6} sx={{ my: 3 }}>
				<AppAsyncOfficesAutocomplete
					multiple
					urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/offices`}
					value={selectorData}
					onChange={e => setSelectorData(e.target.value)}
				/>
			</Grid>}
			{multipleUsersModalOption.value === USER_MULTI_OPTIONS.MASTERS && <Grid item xs={6} sx={{ my: 3 }}>
				<AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
					multiple
					useLoading
					urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/master-users`}
					placeholder="Masters"
					value={selectorData}
					onChange={e => setSelectorData(e.target.value)}
				/>
			</Grid>}
			<Grid item xs={3}/>
			<Grid item xs={12}>
				<Divider sx={{ mb: 3 }}/>
			</Grid>
			<Grid item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
				<ButtonLoadingSeeker
					loading={isSubmitLoading}
					startIcon={<IconSeeker icon="trash"/>}
					sx={{ backgroundColor: "error.main" }}
					onClick={() => handleSubmit(modalPayload, `${BACKEND_APIS.USER}/remove-multi`)}
					disabled={!selectorData.length}
				>
					Confirm Deletion
				</ButtonLoadingSeeker>
				<ButtonLoadingSeeker
					loading={isSubmitLoading}
					onClick={() => handleSubmit(modalPayload, `${BACKEND_APIS.USER}/add-multi`)}
					startIcon={<IconSeeker icon="edit"/>}
					sx={{ backgroundColor: "warning.main" }}
					disabled={!selectorData.length}
				>
					Confirm Edition
				</ButtonLoadingSeeker>
			</Grid>
		</Grid>

	</ModalSeeker>
}